import React from 'react';
import styled from '@emotion/styled';
import { Skeleton } from '@robinpowered/design-system';
import { useTranslation } from 'react-i18next';

export const SearchLoadingState: React.FC = () => {
  const { t } = useTranslation('globalNavigation');

  return (
    <LoadingState data-testid="search-overlay-loading-state">
      <LoadingTitle>{t('searchOverlay.loading')}</LoadingTitle>
      <SkeletonRow width="100%" height="64px" />
      <SkeletonRow width="100%" height="64px" />
    </LoadingState>
  );
};

const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 212px;
  padding: 20px 16px 12px;
`;

const LoadingTitle = styled.h3`
  margin: 0 0 16px;
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

const SkeletonRow = styled(Skeleton)`
  border-radius: 8px;

  & + & {
    margin-top: 12px;
  }
`;
